module.exports = __webpack_public_path__ + "img/supply_workflow_1.8a38e37d.png";